{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Prilagođeni atributi",
    "HEADER_BTN_TXT": "Dodaj prilagođeni atribut",
    "LOADING": "Dohvaćanje prilagođenih atributa",
    "DESCRIPTION": "Prilagođeni atribut bilježi dodatne podatke o vašim kontaktima ili razgovorima, npr. pretplatnički paket ili datum prve kupnje. Možete dodati različite vrste prilagođenih atributa, poput teksta, popisa ili brojeva, kako biste zabilježili upravo one podatke koji su vam potrebni.",
    "LEARN_MORE": "Saznajte više o prilagođenim atributima",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Tekst",
      "NUMBER": "Broj",
      "LINK": "Poveznica",
      "DATE": "Datum",
      "LIST": "Popis",
      "CHECKBOX": "Potvrdni okvir",
      "TEXT_AREA": "Tekstno područje"
    },
    "ADD": {
      "TITLE": "Dodaj prilagođeni atribut",
      "SUBMIT": "Izradi",
      "CANCEL_BUTTON_TEXT": "Odustani",
      "FORM": {
        "NAME": {
          "LABEL": "Prikazni naziv",
          "PLACEHOLDER": "Unesite prikazni naziv prilagođenog atributa",
          "ERROR": "Naziv je obavezan"
        },
        "DESC": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Unesite opis prilagođenog atributa",
          "ERROR": "Opis je obavezan"
        },
        "MODEL": {
          "LABEL": "Primjenjuje se na",
          "PLACEHOLDER": "Odaberite jednu mogućnost",
          "ERROR": "Model je obavezan"
        },
        "TYPE": {
          "LABEL": "Vrsta",
          "PLACEHOLDER": "Odaberite vrstu",
          "ERROR": "Vrsta je obavezna",
          "LIST": {
            "LABEL": "Vrijednosti popisa",
            "PLACEHOLDER": "Unesite vrijednost i pritisnite Enter",
            "ERROR": "Potrebna je barem jedna vrijednost"
          }
        },
        "KEY": {
          "LABEL": "Ključ",
          "PLACEHOLDER": "Unesite ključ prilagođenog atributa",
          "ERROR": "Ključ je obavezan",
          "IN_VALID": "Neispravan ključ"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex uzorak",
          "PLACEHOLDER": "Unesite regex uzorak prilagođenog atributa. (Neobavezno)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex savjet",
          "PLACEHOLDER": "Unesite savjet za regex uzorak. (Neobavezno)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Omogući regex provjeru"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Prilagođeni atribut uspješno je dodan!",
        "ERROR_MESSAGE": "Nije moguće stvoriti prilagođeni atribut. Pokušajte ponovno kasnije."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Prilagođeni atribut uspješno je izbrisan.",
        "ERROR_MESSAGE": "Nije moguće izbrisati prilagođeni atribut. Pokušajte ponovno."
      },
      "CONFIRM": {
        "TITLE": "Jeste li sigurni da želite izbrisati {attributeName}?",
        "PLACE_HOLDER": "Za potvrdu upišite {attributeName}",
        "MESSAGE": "Brisanjem ćete ukloniti prilagođeni atribut",
        "YES": "Izbriši ",
        "NO": "Odustani"
      }
    },
    "EDIT": {
      "TITLE": "Uredi prilagođeni atribut",
      "UPDATE_BUTTON_TEXT": "Ažuriraj",
      "TYPE": {
        "LIST": {
          "LABEL": "Vrijednosti popisa",
          "PLACEHOLDER": "Unesite vrijednosti i pritisnite Enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Prilagođeni atribut uspješno je ažuriran",
        "ERROR_MESSAGE": "Došlo je do pogreške pri ažuriranju prilagođenog atributa. Pokušajte ponovno"
      }
    },
    "TABS": {
      "HEADER": "Prilagođeni atributi",
      "CONVERSATION": "Razgovor",
      "CONTACT": "Kontakt"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Ime",
        "DESCRIPTION": "Opis",
        "TYPE": "Vrsta",
        "KEY": "Ključ"
      },
      "BUTTONS": {
        "EDIT": "Uredi",
        "DELETE": "Izbriši"
      },
      "EMPTY_RESULT": {
        "404": "Nema stvorenih prilagođenih atributa",
        "NOT_FOUND": "Nema konfiguriranih prilagođenih atributa"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex uzorak",
        "PLACEHOLDER": "Unesite regex uzorak prilagođenog atributa. (Neobavezno)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex savjet",
        "PLACEHOLDER": "Unesite savjet za regex uzorak. (Neobavezno)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Omogući regex provjeru"
      }
    }
  }
}
